import React, { FC } from 'react';

import formatMoney from '@/utils/formatter/formatMoney';

export const Money: FC<{ amount?: number; currency?: string }> = ({
  amount,
  currency,
}) => <span className="tabular-nums">{formatMoney(amount, currency)}</span>;
